/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Form_SupplierInputs */

const vi_aml_form_supplier = /** @type {(inputs: Aml_Form_SupplierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhà cung cấp`)
};

/**

* @param {Aml_Form_SupplierInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_form_supplier = /** @type {((inputs?: Aml_Form_SupplierInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Form_SupplierInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_form_supplier(inputs)
});